'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isWednesday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/isWednesday.js
// module id = 328
// module chunks = 0